<script lang="ts">
  interface Props {
    children?: import("svelte").Snippet;
  }

  let { children }: Props = $props();
  // (c) Cognisoft Aps, 2022
</script>

<!-- HTML ===================================================== -->

<h1>Intern fejl i Routing</h1>
{#if children}{@render children()}{:else}Routing-variabel mangler{/if}
